<template>
  <v-app>
    <v-main>
      <router-view v-bind="$route.meta" />
    </v-main>

    <FooterShell />
  </v-app>
</template>

<script>
import FooterShell from "./components/shell/FooterShell.vue";

export default {
  computed: {
    name() {
      return "CONTROL P - Soluções em Impressões - Sinop/MT";
    },
  },
  methods: {
    updateDocumentTitle() {
      if (this.name && this.$route.name) {
        document.title = `${this.$route.name} | ${this.name}`;
      } else if (this.name && !this.$route.name) {
        document.title = this.name;
      } else if (!this.name && this.$route.name) {
        document.title = this.$route.name;
      } else {
        document.title = "";
      }
    },
  },
  watch: {
    $route() {
      this.updateDocumentTitle();
    },
    name() {
      this.updateDocumentTitle();
    },
  },
  created() {
    this.updateDocumentTitle();
  },
  components: {
    FooterShell,
  },
};
</script>
